import { ref, computed, onMounted } from 'vue'
import { renderMarkdown, renderTrustedMarkdown } from '~/functions/markdown'


export default {
  __name: 'CustomComparisonModal',
  props: {
  onlyFactor: {
    type: Boolean,
    default: false,
  },
  solution: {
    type: Boolean,
    default: false,
  },
  initialData: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['selectItem', 'closeModal'],
  setup(__props, { emit }) {

const props = __props;





const CUSTOM_NAME = ref(null)
const CUSTOM_GHG_FACTOR = ref(null)
const CUSTOM_UNIT = ref(null)
const CUSTOM_EVIDENCE = ref('')

const updateRefsFromProps = () => {
  const isEmpty =
    !props.initialData ||
    (Object.keys(props.initialData).length === 0 &&
      props.initialData.constructor === Object)

  if (isEmpty) {
    CUSTOM_NAME.value = null
    CUSTOM_GHG_FACTOR.value = null
    CUSTOM_UNIT.value = null
    CUSTOM_EVIDENCE.value = ''
  } else {
    CUSTOM_NAME.value = props.solution
      ? props.initialData?.solutionConceptName || null
      : props.initialData?.baselineConceptName || null
    CUSTOM_GHG_FACTOR.value = props.solution
      ? props.initialData?.solutionGhgFactor || null
      : props.initialData?.baselineGhgFactor || null
    CUSTOM_UNIT.value = props.solution
      ? props.initialData?.solutionUnitName || null
      : props.initialData?.baselineUnitName || null
    CUSTOM_EVIDENCE.value = props.solution
      ? props.initialData?.solutionEvidence || ''
      : props.initialData?.baselineEvidence || ''
  }
}

onMounted(() => {
  updateRefsFromProps()
})

const showSelectingEmissionFactorGuidance = ref(false)

const hasAmount = computed(() => {
  const v = CUSTOM_GHG_FACTOR.value
  return !(v === '' || v === null || v === undefined)
})
const hasUnit = computed(() => {
  const v = CUSTOM_UNIT.value
  return !(v === '' || v === null || v === undefined)
})
const disableAdd = computed(() => !(hasAmount.value || hasUnit.value))

const addCustomGHG = () => {
  emit('selectItem', {
    name: CUSTOM_NAME.value,
    factor: CUSTOM_GHG_FACTOR.value,
    unit: CUSTOM_UNIT.value,
    evidence: CUSTOM_EVIDENCE.value,
    customBaselineConcept: true,
    isSolution: props.solution
  })
}

const closeModal = () => {
  emit('closeModal')
}

return { __sfc: true,props, emit, CUSTOM_NAME, CUSTOM_GHG_FACTOR, CUSTOM_UNIT, CUSTOM_EVIDENCE, updateRefsFromProps, showSelectingEmissionFactorGuidance, hasAmount, hasUnit, disableAdd, addCustomGHG, closeModal, renderMarkdown, renderTrustedMarkdown }
}

}